export default __webpack_public_path__ + "static/media/checkmark.2ff8e26d.svg";